import React from 'react'
import {uploadFile, visualizeLoad} from "../../api/api";
import {Button, Modal, Alert, Table as TableAntd, Upload} from 'antd'
import {InboxOutlined, UploadOutlined,
} from "@ant-design/icons"
import TableDataSource from "../../utils/TableDataSource";
import {DefaultProps, PaginatedLoad, RefTable} from "../RefTable";
const { Dragger } = Upload;

const HS6PUpload = (props) => {

    const [source, setSource] = React.useState(new TableDataSource());
    const [refresh, setRefresh] = React.useState(1);
    const [openWindow, setOpenWindow] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [showTable, setShowTable] = React.useState(false);
    const [alert, setAlerts] = React.useState({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});

    const columns = [
        {
            title: 'Row Index',
            dataIndex: 'rowId',
            key: 'rowId',
        },
        {
            title: 'Error / Warning',
            dataIndex: 'error',
            key: 'error',
        },
        {
            title: 'Field',
            dataIndex: 'columnName',
            key: 'columnName',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
        },
    ];

    async function customUpload(data) {

        setAlerts({
            success: false, error: false, uploading: true, rowCount:0, uploadedRowCount:0
        });
        setShowTable(false);
        const formData = new FormData();
        formData.append('data_type', 'hs6p');
        formData.append('file',data.file);
        const response = await uploadFile(formData);
        const errorMessage = 'File upload failed';

        if (response) {
            const { statusText } = response;
            const data = response.data[0];
            console.log(response)
            const {errorList, status, noOfRowsUploaded, noOfRows, excludeRowCount, errorMsg} = data;
            setShowTable(false);
            setSource(new TableDataSource());
            setRefresh(refresh+1);

            setAlerts({
                success: true, error: false, uploading: false, rowCount:noOfRows, uploadedRowCount:noOfRowsUploaded, excludeRowCount: excludeRowCount
            });

            if (status === 'success') {
                if (errorList && errorList.length > 0) {
                    setShowTable(true);
                    const results= errorList.map(row => ({
                        key: row.id,
                        rowId: row.row,
                        columnName: row.column,
                        value: row.value,
                        error: row.error
                    }));
                    setErrors(results);
                } else {
                    setShowTable(false);
                }

            } else {
                setAlerts({
                    success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMsg
                });
                setShowTable(false);
            }
        } else {
            setAlerts({
                success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMessage
            });
        }
    }

    return <React.Fragment>
        <Modal
            centered
            closable={true}
            onCancel={() => {
                setOpenWindow(false);
                setErrors([]);
                setAlerts({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
                setShowTable(false);
            }}
            footer={null}
            title={`HS6P File Upload`}
            visible={openWindow}
        >
            <div>
                <Dragger customRequest={customUpload} accept={".xlsx"} multiple={false} showUploadList={false}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single excel file upload.
                    </p>
                </Dragger>
            </div>
            <div style={{marginBlock: '15px'}}>
                {alert.uploading && <Alert
                    message="File uploading ....."
                    type="info"
                    showIcon
                />}
                {alert.success && <Alert
                    message="File uploaded successfully"
                    description= {`${alert.uploadedRowCount} row(s) out of  ${alert.rowCount} row(s) uploaded and ${alert.excludeRowCount} row(s) skipped with duplicated HS6P code`}
                    type="success"
                    showIcon
                />}
                {alert.error && <Alert
                    message={`${alert.errorMsg}`}
                    type="error"
                    showIcon
                />}
            </div>
            <div style={{marginBlock: '15px'}}>
                {showTable && <TableAntd columns={columns} dataSource={errors} size={'middle'}>
                </TableAntd>}
            </div>
        </Modal>
        <Button style={{ width: 160 }} icon={<UploadOutlined />} onClick={() => setOpenWindow(true)}>Upload File</Button>
    </React.Fragment>
}




export const HS6P = (props)=><RefTable {...props}/>;

HS6P.defaultProps = {
    ...DefaultProps,
    tableName: "hs6p_code",
    tableSchema: "hs6p_code",
    edit: true,
    title: "HS6+ Codes",
    theadHeight: 40,
    tfootHeight: 50,
    fetch: PaginatedLoad,
    customActionElements:[<HS6PUpload key={"upload-action"}/>],
    enrichColumns: (columns) => columns.map(o=>({...o,minWidth: o.name === "description" ? 'calc(100vw - 600px)' : o.minWidth}))


}